import { capitaliseFirstLetter } from "@shared/translations/src";

/**
 * Creates a standardized "field is required" error message
 */
export const getRequiredFieldMessage = (displayName: string) => `${capitaliseFirstLetter(displayName)} is required.`;

/**
 * Creates a standardized max length error message for string fields
 */
export const getMaxStringLengthMessage = ({ displayName, maxLength }: { displayName: string; maxLength: number }) =>
  `${capitaliseFirstLetter(displayName)} must not exceed ${maxLength} characters.`;
